import { add_color_class, hide_dropdown_sidebar } from "./subSidebarListItemWithSubMenu";

export class MobileSidebar
{
    constructor(loadPageInDashboard, queryClient, setPageName)
    {
        this.setPageName            =   setPageName;
        this.queryClient            =   queryClient;
        this.loadPageInDashboard    =   loadPageInDashboard;
        this.Options                =   null;
    }

    handleSidebarIconClick(event, Options) 
    {   
        window.history.replaceState(null, null, Options.link);
        this.Options = Options;
        var key = event.currentTarget.title;
        
        this.queryClient.setQueryData('selectedSubSidebarOptions', () => key);
        this.loadPageInDashboard(this.queryClient, this.setPageName);
        this.setPageName(key);
        this.activateSidebar(event.currentTarget);
        this.activateSubsidebar(event.currentTarget, this.Options);

    }

    activateSidebar(element) 
    {
        this.deactiveAllSidebarOption();
        this.activeSidebarOption(element);
    }

    activateSubsidebar(element, Options) 
    {
        if( Options['subSidebar_options']!=null && !this.subsidebarNotAllowedForUrls() )
        {
            this.showMobileSidebar();
            this.changeDeactiveSidebarOptionColor(element);
            this.deactiveAllSubsidebarOption();
            this.activeSubsidebarOption(this.queryClient);
        }
        else
        {
            this.hideMobileSubsidebar();
            this.changeActiveSidebarOptionColor(element);
        }
    }

    deactiveAllSidebarOption()
    {
        const all_sidebar_elements = document.getElementsByClassName('MainSidebar__Item');
        for ( const element of all_sidebar_elements) 
        {
            element.classList.remove('Active');
        };
    }

    activeSidebarOption(element)
    {
        // const current_element   =   element;
        // const parent_element    =   current_element?.closest('.MobileMenu__Item');
        // parent_element.classList.add('Active');
    }

    showMobileSidebar() 
    {
        let SubSidebar = document.getElementsByClassName('SubSidebar')[0];

        if(SubSidebar != undefined )
        {
            // document.getElementsByClassName('Sidebar')[1].classList.add('WithSubsidebar'); 
            const sub_sidebar           =   document.querySelector('.MobileMenuContainer .MobileSubMenuBar .SubSidebar');
            sub_sidebar.style.display   =   'block';
            SubSidebar.classList.add('SubSidebar__Active');
        }
    }

    subsidebarNotAllowedForUrls()
    {
        var is_path_match   = false;
        var current_url     = window.location.pathname;
        var hide_subsidebar = [
                                    /^\/clients\/jobs\/job$/,
                                    /^\/admins\/clients\/client$/
                                ]

        for( var element of hide_subsidebar)
        {
            if(current_url.match(element) != null )
            {
                is_path_match = true;
                break;
            }            
        }

        return is_path_match && this.queryClient.getQueryData('selectedSubSidebarOptions')!="settings";
    }

    changeActiveSidebarOptionColor(element) 
    {
        const current_element = element;
        const parent_element = current_element.closest('.MainSidebar__Item');
        parent_element?.classList.add('Subsidebar');
    }

    deactiveAllSubsidebarOption()
    {
        document.querySelectorAll('.SubSidebarItemText').forEach(function(element) {
            element.classList.remove('color-white');
        })
    }

    activeSubsidebarOption(queryClient)
    {
        let active_element_name         = queryClient.getQueryData('selectedSubSidebarOptions');
        let active_parent_element_name  = queryClient.getQueryData('selectedParentSubSidebarOptions');
        let active_element              = document.querySelectorAll('[data-item-title="'+active_element_name+'"]')[0];
        let active_parent_element       = document.querySelectorAll('[data-item-title="'+active_parent_element_name+'"]')[0];
        active_element                 != undefined ? active_element.classList.add('color-white') : '';
        active_parent_element          != undefined ? add_color_class(queryClient) : '';
    }

    hideMobileSubsidebar() 
    {
        let SubSidebar = document.getElementsByClassName('SubSidebar')[0];
        if(SubSidebar != undefined)
        {
            SubSidebar.style.display = 'none'; 
        }
    }

    changeDeactiveSidebarOptionColor(element) 
    {
        const current_element = element;
        const parent_element = current_element?.closest('.MainSidebar__Item');
        parent_element?.classList?.remove('Subsidebar');
    }

    handleClickOutside(event)
    {
        var hamburgerMenu = document.getElementsByClassName('HamburgerMenu__List')[0];
        if(hamburgerMenu.classList.contains('Open') && !event.target.parentElement.classList.contains('hamburger-menu'))
        {
            hamburgerMenu.classList.remove('Open');
            hamburgerMenu.classList.add('Close');
            this.queryClient.setQueryData('hamburgerMenuStatus', ()=> {return "Close"});
           
        }
        // INFO :- Outside click of the dropdown
        var dropdown_subsidebar_item = document.querySelector('.MobileSubMenuBar .SubSidebarItem');
        if(dropdown_subsidebar_item)
        {
            hide_dropdown_sidebar();
            dropdown_subsidebar_item.classList.remove('Open');
            dropdown_subsidebar_item.classList.add('Close');
        }
    };

    subsidebarChangeIcon(current_step)
    {
        var elements = Array.from(document.getElementsByClassName('SubSidebarItem'));
        elements.forEach((element, index) =>
        {
          if(index < current_step)
          {
              elements[index].classList.remove('InProgress');
              elements[index].classList.add('Completed');
          }
          else if(index==current_step)
          {
            elements[index].classList.remove('Completed');
            elements[index].classList.add('InProgress');
          }
          else
          {
            elements[index].classList.remove('Completed');
            elements[index].classList.remove('InProgress');
          }
        })
        
    }
}

